import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Link2, Plus, Trash2, Save } from 'lucide-react';

export default function AdminLabelMappingsPage() {
  const [mappings, setMappings] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newMapping, setNewMapping] = useState({ label_name: '', user_id: '' });

  const load = async () => {
    try {
      const [mRes, uRes] = await Promise.all([api.get('/statements/label-mappings'), api.get('/admin/users?limit=500')]);
      setMappings(mRes.data.mappings); setUsers(uRes.data.users);
    } catch (e) {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!newMapping.label_name || !newMapping.user_id) return toast.error('Compila tutti i campi');
    try { await api.post('/statements/add-label-mapping', newMapping); toast.success('Mapping aggiunto'); setNewMapping({ label_name: '', user_id: '' }); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Errore'); }
  };

  return (
    <div className="max-w-3xl">
      <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-2"><Link2 size={24} className="text-yellow-400" />Label Mappings</h1>
      <p className="text-sm text-gray-400 mb-6">Associa i nomi delle label presenti nel file master del distributore agli utenti della piattaforma. Quando carichi un rendiconto, il sistema usa questi mapping per assegnare automaticamente i dati al giusto utente.</p>

      {/* Add new */}
      <div className="card-dark p-5 mb-6">
        <h2 className="font-bold text-white mb-3 flex items-center gap-2"><Plus size={16} />Nuovo Mapping</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <input className="input-field-dark" placeholder="Nome label nel file master..." value={newMapping.label_name} onChange={e => setNewMapping(p => ({ ...p, label_name: e.target.value }))} />
          <select className="input-field-dark" value={newMapping.user_id} onChange={e => setNewMapping(p => ({ ...p, user_id: e.target.value }))}>
            <option value="">Seleziona utente...</option>
            {users.filter(u => u.role !== 'admin').map(u => <option key={u.id} value={u.id}>{u.first_name} {u.last_name} ({u.email})</option>)}
          </select>
          <button onClick={add} className="btn-admin">Aggiungi</button>
        </div>
      </div>

      {/* Existing mappings */}
      {loading ? <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div> : (
        <div className="space-y-2">{mappings.map(m => (
          <div key={m.id} className="card-dark p-3 flex items-center gap-3">
            <Link2 size={14} className="text-yellow-400" />
            <span className="font-medium text-white flex-1">"{m.master_file_label_name}"</span>
            <span className="text-gray-400">→</span>
            <span className="text-sm text-gray-300">{m.first_name} {m.last_name} ({m.email})</span>
            {m.label_name_internal && <span className="text-xs text-gray-500">[{m.label_name_internal}]</span>}
          </div>
        ))}{mappings.length === 0 && <div className="card-dark p-8 text-center text-gray-500">Nessun mapping configurato</div>}</div>
      )}
    </div>
  );
}
